import {
  Modal,
  useBreakLG,
  useBreakMD,
  useBreakXL,
  useModal,
} from "@monta/design-system";
import { lazy, Suspense, type Dispatch, type SetStateAction } from "react";
import DescriptiveQuestion from ".";
import { useSelectedStudentIdContext } from "../exam-results/context/studentsList/context";
import { useGetQuestions } from "./utils";

type Props = {
  questionModalId: number | null;
  setQuestionModalId: Dispatch<SetStateAction<number | null>>;
};

const MathJaxContext = lazy(() => import("../mathjax/Context"));

export const DqModal = (props: Props) => {
  const { questionModalId, setQuestionModalId } = props;
  const isMD = useBreakMD();
  const isLG = useBreakLG();
  const isXL = useBreakXL();
  const { selectedStudentId } = useSelectedStudentIdContext();

  const modalController = useModal();

  const foundedQuestion = useGetQuestions(
    selectedStudentId,
    questionModalId as number,
  )[0];

  return (
    <Suspense fallback={<></>}>
      <MathJaxContext>
        <Modal
          {...modalController}
          isOpen={!!questionModalId}
          bottomSheetOnMobile
          borderRadius="4"
          width={isXL ? 1200 : isLG ? 768 : isMD ? 480 : "auto"}
          maxWidth={1200}
          minHeight={400}
          close={() => setQuestionModalId(null)}
          style={{
            display: "flex",
          }}
        >
          {foundedQuestion && Object.keys(foundedQuestion).length && (
            <DescriptiveQuestion
              id={questionModalId as number}
              shouldRenderAs="modal"
            />
          )}
        </Modal>
      </MathJaxContext>
    </Suspense>
  );
};
